/** Quote group (canonical `EBXrikCU`). The Accepted Quote Workbench: flip an
 *  accepted quote into a live job. Three POSTs — accept (sent→accepted), the
 *  read-only provision plan (match candidates + editable proposals), and the
 *  single commit that materialises job/client/fees/drawing-set. Public at the
 *  Xano level today; the staff token is attached anyway (group === "quote").
 *  Goes through the shared client. */

import { api } from "./client";
import type { ProvisionPlan, ProvisionRequest, ProvisionResult, QuoteAcceptResponse } from "@/types";

/** POST quote/{id}/accept — sent → accepted (idempotent). Returns the new
 *  status + accepted_at; surfaces a precondition error on a terminal quote. */
export function acceptQuote(quoteId: number): Promise<QuoteAcceptResponse> {
  return api.post<QuoteAcceptResponse>("quote", `quote/${quoteId}/accept`);
}

/** POST quote/{id}/provision-plan — the server's read-only proposal: accepted
 *  lines, job/client match candidates + the editable "new" forms, and the fee /
 *  drawing-set seeds. No writes; the workbench edits a working copy of this. */
export function getProvisionPlan(quoteId: number): Promise<ProvisionPlan> {
  return api.post<ProvisionPlan>("quote", `quote/${quoteId}/provision-plan`);
}

/** POST quote/{id}/provision — the single commit. Materialises the chosen
 *  actions (create/link job + client, fees, drawing set) and marks the quote
 *  converted. Refuses an already-provisioned quote (surface the precondition). */
export function provisionQuote(quoteId: number, body: ProvisionRequest): Promise<ProvisionResult> {
  return api.post<ProvisionResult>("quote", `quote/${quoteId}/provision`, { body });
}
